import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section id="categories" className="relative py-20 md:py-28 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium mb-4" style={{ fontFamily: 'var(--font-label)' }}>
            Browse by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Explore Product Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto" style={{ fontFamily: 'var(--font-body)' }}>
            Select a category below to browse curated Superbuy Spreadsheet collections on our main website. 
            Every category is organized for easy discovery.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-14">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-white border border-background-300 rounded-2xl px-5 py-4 pr-12 text-foreground-800 text-sm font-medium cursor-pointer focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
              style={{ fontFamily: 'var(--font-label)' }}
            >
              <option value="">-- Select a Category --</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
          <p className="text-foreground-400 text-xs text-center mt-3" style={{ fontFamily: 'var(--font-body)' }}>
            Selecting a category opens the corresponding page on our main website
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 bg-white rounded-2xl border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 text-center leading-tight whitespace-nowrap" style={{ fontFamily: 'var(--font-label)' }}>
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}